module.exports = __webpack_public_path__ + "img/selected2-min.a7045e2e.png";